import { useEffect, useState } from "react";
import { api } from "../../utils/api";
import Skeleton from "../common/loading/Skeleton";
import HomeTagCarousel, {
	HOME_CAROUSEL_CARD_CLASS,
} from "./tag/HomeTagCarousel";
import HomeCarouselCard from "./HomeCarouselCard";
import HomeRowTitle, { homeCarouselAllHref } from "./HomeRowTitle";
import { enrichCarouselsClipAccess } from "./enrichCarouselsClipAccess";

export default function CustomCarousels({ isDesktop }) {
	const [carousels, setCarousels] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;

		const load = () => {
			setIsLoading(true);
			api
				.homeCarousels()
				.then((data) => enrichCarouselsClipAccess(data ?? []))
				.then((data) => {
					if (!cancelled) setCarousels(data);
				})
				.catch(() => {
					if (!cancelled) setCarousels([]);
				})
				.finally(() => {
					if (!cancelled) setIsLoading(false);
				});
		};

		load();
		window.addEventListener("app-auth-change", load);
		return () => {
			cancelled = true;
			window.removeEventListener("app-auth-change", load);
		};
	}, []);

	if (isLoading) {
		return (
			<div className="mx-auto mt-2 grid w-full max-w-[1200px] gap-8 px-4">
				<Skeleton variant="grid" type="workshop" count={4} />
				<Skeleton variant="grid" type="webinar" count={4} />
			</div>
		);
	}

	const visible = carousels.filter((c) =>
		(c.items ?? []).some((item) => item.card)
	);
	if (visible.length === 0) {
		return null;
	}

	return (
		<div className="flex w-full flex-col gap-0">
			{visible.map((carousel) => {
				const items = carousel.items.filter((item) => item.card);
				const cards = items.map((item) => item.card);
				const allHref = homeCarouselAllHref(cards);

				return (
					<section
						key={carousel.id}
						className={[
							"mx-auto w-full max-w-[1200px] px-4",
							isDesktop ? "mb-8" : "mb-6",
						].join(" ")}
						aria-label={carousel.title}
					>
						<HomeRowTitle title={carousel.title} allHref={allHref} />
						<HomeTagCarousel
							swiperClassName={`home-custom-carousel-${carousel.id}`}
							slides={items.map((item) => ({
								key: item.id,
								node: (
									<div className={HOME_CAROUSEL_CARD_CLASS}>
										<HomeCarouselCard card={item.card} />
									</div>
								),
							}))}
						/>
					</section>
				);
			})}
		</div>
	);
}
